module.exports = __webpack_public_path__ + "img/32ne.d57a4ba9.svg";